<template>
    <DModal
        :show="show"
        :title="__('administrations.cron_jobs.modals.execute.title', {command: item.job})"
        :close-color-secondary="true"
        is-big
        overflow-auto
        @close="closeModal"
    >
        <div
            class="modal-base"
        />
        <DForm
            class="content-padding"
            @submit.prevent="executeCommand"
        >
            <DFormRow
                v-for="(option, index) in options"
                :key="option.name"
                :label="option.name !== 'force' ? option.name : ''"
                :hint="option.name !== 'force' ? option.description : ''"
            >
                <DSwitch
                    v-if="option.type === 'boolean'"
                    :id="`option_${option_name}`"
                    v-model="option.value"
                    color="success"
                    variant="3d"
                />
                <DInput
                    v-else-if="option.type === 'text'"
                    :id="`option_${option_name}`"
                    :key="index"
                    v-model="option.value"
                    :index="index"
                />
                <DInput
                    v-else-if="option.type === 'date'"
                    :id="`option_${option_name}`"
                    v-model="option.value"
                    type="date"
                />
            </DFormRow>
        </DForm>
        <template #actions>
            <DButton
                :label="__('administrations.cron_jobs.modals.execute.submit')"
                color="primary"
                :disabled="isInLoadingState"
                @click="executeCommand"
            />
        </template>
        <DAlert
            v-if="message !== null"
            class="content-margin"
            :color="isSuccessful ? 'success' : 'danger'"
        >
            {{ message }}
        </DAlert>
    </DModal>
</template>

<script>

export default {
    name: 'ShowCronJobModal',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        item: {
            type: Object,
            default: () => {
                return null
            }
        }
    },
    emits: ['close'],
    data () {
        return {
            errors: [],
            options: [],
            isSuccessful: false,
            message: null
        }
    },
    created () {
        window.axios.get(this.$route('administrations.cron-jobs.options', { cron_job: this.item }))
            .then((response) => {
                this.options = response.data.options
            })
            .catch((error) => {
                this.error = error.response.data.error
            })
    },
    methods: {
        closeModal () {
            this.errors = []
            this.options = []
            this.$emit('close')
        },
        async executeCommand () {
            this.message = null

            const response = await window.axios(this.$route('administrations.cron-jobs.execute', {
                cron_job: this.item,
                command: this.item.job,
                options: this.options
            }))

            this.isSuccessful = response.data.success && response.data.pid !== null

            if (response.data.success === false) {
                this.message = response.data.message
                return
            }

            this.message = response.data.message
        }
    }
}
</script>
<style lang="scss" scoped>
.content-padding {
    padding: 15px !important;;
}

.content-margin {
    margin: 15px !important;;
}

.command-output {
    background: #ebebeb;
    border-radius: 5px;
    padding: 10px;
}

.modal-base {
    margin: 15px;
    display: grid;
    grid-gap: 15px;

    & .modal-header {
        display: grid;
        grid-gap: 15px;
        grid-template-columns: 1fr auto;
        align-items: center;
    }
    & .raw-textbox {
        font-family: monospace, monospace;
        white-space: pre-wrap;
    }
}

.loading-box {
    height: 250px;
    display: flex;
    justify-content: center;
    align-items: center;

    & .loading {
        animation: loading 0.4s linear infinite;
    }
}

@keyframes loading {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
